/* --- CONFIGURACIÓN POR GRUPOS --- */
const GRUPOS_REGALO = [
    {
        idsActivadores: [ // PREVENTA
            '7704232755262', //adventure
            '8190136352830', //explorer
            '8193788903486', //bat explorer
            '8188232237118', //newpath
            '8193782513726', //bat newpath
            '7696696901694', //freedom
            '7709761863742', //bat freedom
            '7841006813246', //titan
            '41434957676606', //panel400
        ],
        minimoPrecio: 700000,
        textoPromo: '¡Te enviaremos de regalo un Sunpack!',
        imgFija: 'https://genectra.cl/cdn/shop/files/s1.webp?v=1756144392&width=1024',
        nombreFijo: 'PANEL PLEGABLE<br>SUNPACK 12w',
        regalo1: { id: '68022007562302', nombre: 'PANEL PLEGABLE<br>SUNPACK 12w', img: 'https://genectra.cl/cdn/shop/files/s1.webp?v=1756144392&width=1024' },
        regalo2: { id: 'ID_VAR', nombre: 'REGALO D', img: 'URL' }
    }
];

function gestionarRegaloVisual(precio) {
    const productIdInput = document.querySelector('input[name="product-id"]');
    if (!productIdInput) return;

    const configActual = GRUPOS_REGALO.find(grupo => grupo.idsActivadores.includes(productIdInput.value));
    if (!configActual || configActual.regalo1.id === 'ID_VAR') return;

    const contenedorVariantes = document.querySelector('.product-options') || 
                                document.querySelector('.product-form__input') || 
                                document.querySelector('.product-options__default');
    
    let box = document.querySelector('.giftBox');

    if (precio >= configActual.minimoPrecio && contenedorVariantes) {
        if (!box) {
            // 1. Validaciones de contenido
            const tieneRegalo2 = configActual.regalo2 && configActual.regalo2.id !== 'ID_VAR' && configActual.regalo2.id !== '';
            const esMismaImagen = configActual.imgFija === configActual.regalo1.img;
            
            // 2. Definir Grid: Si la imagen es la misma, no hay columna para la fija ni para el "+"
            let gridCols = tieneRegalo2 ? '1fr auto 1fr 1fr' : '1fr auto 1fr';
            if (esMismaImagen) gridCols = tieneRegalo2 ? '1fr 1fr' : '1fr';

            box = document.createElement('div');
            box.className = 'giftBox';
            box.style.cssText = 'margin: 15px 0; padding: 12px; border: 1px solid #e0e0e0; border-radius: 8px; background: #fff; clear: both;';
            
            let htmlContent = `
                <h5 class="titGifts" style="margin:0 0 5px 0; font-size: 14px;">🎁 ¡Desbloqueaste Regalo Exclusivo!</h5>
                <p style="text-align:left; font-size:11px; margin: 0 0 10px 0; font-weight:bold; text-transform: uppercase; color: #333;">
                    ${configActual.textoPromo}
                </p>
                <div style="display: grid; grid-template-columns: ${gridCols}; align-items: center; gap: 8px;">
            `;

            // 3. Solo mostrar la imagen fija y el "+" si NO es la misma imagen que el regalo
            if (!esMismaImagen) {
                htmlContent += `
                    <div class="gift-card" style="opacitiy: 1 !important; display: flex; flex-direction: column; align-items: center; text-align: center; border: 1px solid #f0f0f0; border-radius: 6px; padding: 6px; background: #fafafa;">
                        <img src="${configActual.imgFija}" style="width: 55px; height: 55px; object-fit: cover; border-radius: 4px; margin-bottom: 4px;">
                        <span class="gift-name">${configActual.nombreFijo}</span>
                    </div>
                    <span style="font-size: 28px; font-weight: 300; color: #ff6e1d;">+</span>
                `;
            }

            // 4. Regalo 1 (Siempre visible)
            htmlContent += `
                <label class="gift-card" style="opacitiy: 1 !important; display: flex; flex-direction: column; align-items: center; border: 1.5px solid #000; border-radius: 6px; padding: 6px; cursor: pointer; background: #fff; transition: 0.2s; text-align: center;">
                    <input type="radio" name="gift-selection" value="${configActual.regalo1.id}" checked style="display:none;">
                    <img src="${configActual.regalo1.img}" style="width: 55px; height: 55px; object-fit: contain; margin-bottom: 4px;">
                    <span class="gift-name">${configActual.regalo1.nombre}</span>
                </label>
            `;

            // 5. Regalo 2 (Condicional)
            if (tieneRegalo2) {
                htmlContent += `
                    <label class="gift-card" style="display: flex; flex-direction: column; align-items: center; border: 1.5px solid #e8e8e8; border-radius: 6px; padding: 6px; cursor: pointer; background: #fff; transition: 0.2s; text-align: center;">
                        <input type="radio" name="gift-selection" value="${configActual.regalo2.id}" style="display:none;">
                        <img src="${configActual.regalo2.img}" style="width: 55px; height: 55px; object-fit: contain; margin-bottom: 4px;">
                        <span class="gift-name">${configActual.regalo2.nombre}</span>
                    </label>
                `;
            }

            htmlContent += `</div>
                <style>
                    .gift-name { font-size: 0.6rem; font-weight: bold; line-height: 1.2; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; min-height: 1.5rem; color: #000; text-align: center; }
                    .gift-card:has(input:checked) { border-color: #000 !important; background: #f9f9f9 !important; }
                    .gift-card:not(:has(input:checked)) { opacity: 0.4; border-color: #eee !important; }
                </style>`;
            
            box.innerHTML = htmlContent;
            contenedorVariantes.after(box);
        }
    } else if (box) {
        box.remove();
    }
}

/* --- 2. MANEJO DE CARRITO (Click Directo) --- */
/*
document.addEventListener('click', function(e) {
    const btn = e.target.closest('button[type="submit"], input[type="submit"]');
    if (!btn) return;
    
    const form = btn.closest('form[action^="/cart/add"]');
    if (!form) return;

    const giftInput = document.querySelector('input[name="gift-selection"]:checked');
    const giftBoxVisible = document.querySelector('.giftBox');

    console.log(giftInput);

    // SOLO intervenimos si el regalo está visible y seleccionado
    if (giftBoxVisible && giftInput) {
        e.preventDefault();
        e.stopImmediatePropagation();

        // 1. Agregar el REGALO primero vía AJAX
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    id: parseInt(giftInput.value),
                    quantity: 1,
                    properties: { '_tipo': 'Regalo Promocional' }
                }]
            })
        })
        .then(response => {
            // 2. Una vez confirmado el regalo, enviamos el formulario principal
            // Esto permite que el tema use su propia lógica (animaciones, cajón lateral, etc.)
            console.log("Regalo añadido, enviando producto principal...");
            form.submit(); 
        })
        .catch(err => {
            console.error("Error al añadir regalo:", err);
            form.submit(); // Enviar normal aunque falle el regalo para no perder la venta
        });
    }
}, true);
*/



/* --- 3. CALCULAR CUOTAS --- */
function calcularCuotas() {
    const opcionesProducto = document.querySelectorAll('.radio-input[name="option-modelo-o-pack"]');

    opcionesProducto.forEach(input => {
        input.addEventListener('change', function() {
            if (this.checked) {
                // Agregamos un pequeño retraso (setTimeout) para dar tiempo a que el tema actualice los precios en el DOM
                setTimeout(() => {
                    const precioOferta = document.querySelector('.price__sale .price-item--sale');
                    const precioRegular = document.querySelector('.price__regular .price-item--regular');
                    const contenedorOferta = document.querySelector('.price__sale');

                    let precioTexto = (contenedorOferta && !contenedorOferta.classList.contains('is-hidden') && precioOferta) 
                        ? precioOferta.innerText 
                        : (precioRegular ? precioRegular.innerText : "0");

                    let precioNumerico = parseInt(precioTexto.replace(/[^0-9]/g, '')) || 0;

                    // 1. Activamos la gestión visual del regalo con el precio actualizado
                    gestionarRegaloVisual(precioNumerico);

                    const elementoTPrice = document.querySelector('.t-price');
                    if (elementoTPrice) {
                        let cuota = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(Math.round(precioNumerico / 12));
                        elementoTPrice.innerText = cuota;
                    }
                }, 100); // 100 milisegundos son suficientes para asegurar la sincronía
            }
        });
    });
    
    const radioCheck = document.querySelector('.radio-input[name="option-modelo-o-pack"]:checked');
    if (radioCheck) radioCheck.dispatchEvent(new Event('change'));
}

/* --- 4. DOM CONTENT LOADED --- */
document.addEventListener("DOMContentLoaded", function() {
    const inputModel = document.querySelector('input[name="product-id"]');
    if (!inputModel) return;
    const nombreModelo = document.querySelector('h1').textContent;
    
    // Mantenemos tus funciones existentes
    botonWhatsapp(nombreModelo);
    agregarLabelsRegalo();
    calcularCuotas(); // Al llamarse aquí, disparará automáticamente el regalo inicial gracias al dispatchEvent
});



function agregarLabelsRegalo() {
    // 1. Seleccionamos todos los contenedores de opciones
    const opciones = document.querySelectorAll('.radio-option');

    opciones.forEach(opcion => {
        const precioElemento = opcion.querySelector('.radio-option__price');
        
        if (precioElemento) {
            // 2. Limpiar el texto para obtener solo números
            const precioTexto = precioElemento.innerText;
            const precioNumerico = parseInt(precioTexto.replace(/[^0-9]/g, '')) || 0;

            // 3. Si es >= 700.000 y no tiene el label ya puesto
            if (precioNumerico >= 700000 && !opcion.querySelector('.label-regalo-badge')) {
                const labelRegalo = document.createElement('span');
                labelRegalo.className = 'label-regalo-badge';
                labelRegalo.innerText = 'Incluye regalo';
                
                // Estilos para que se vea como una etiqueta flotante
                labelRegalo.style.cssText = `
                    position: absolute;
                    top: -7px;
                    right: 10px;
                    background: #000;
                    color: #fff;
                    font-size: 0.6rem;
                    padding: 2px 6px;
                    border-radius: 10px;
                    text-transform: uppercase;
                    font-weight: bold;
                    z-index: 5;
                `;
                
                // Asegurar que el contenedor sea relativo para posicionar el badge
                const radioLabel = opcion.querySelector('.radio-option__label');
                if (radioLabel) {
                    radioLabel.style.position = 'relative';
                    radioLabel.appendChild(labelRegalo);
                }
            }
        }
    });
}




/* AQUI NO TOCAR */

//funcion personalizar boton de whatsapp segun modelo
function botonWhatsapp(modeloName) {
    //personalizar mensaje a whatsapp button
    const botonWa = document.querySelector('.wa-help-box__button');

    botonWa.addEventListener('click', function(e) {
        // 1. Evitamos que abra el link original de inmediato
        e.preventDefault();

        const radioSeleccionado = document.querySelector('.radio-input[name="option-modelo-o-pack"]:checked');
        if (radioSeleccionado) {
        const valorActual = radioSeleccionado.value;
            console.log("El valor seleccionado ahora es:", valorActual);
            modeloName = valorActual;
        } else {
            console.log("No hay ningún radio seleccionado.");
        }

        // 2. Definimos el mensaje base (puedes dejarlo vacío si solo quieres tu variable)
        const mensajeBase = "Hola, necesito más información sobre el ";
        
        // 3. Unimos el mensaje y la variable, y lo codificamos para URL
        const mensajeCompleto = encodeURIComponent(mensajeBase + modeloName);

        // 4. Construimos la nueva URL (usando la base que ya tiene el botón)
        const urlBase = "https://wa.me/56959268677";
        const nuevaUrl = `${urlBase}?text=${mensajeCompleto}`;

        // 5. Redirigimos a la nueva URL en una pestaña nueva
        window.open(nuevaUrl, '_blank');


    });
}



/* ANIMACION Y SEGUIMIENTO DE BOTON AÑADIR AL CARRITO */
document.addEventListener('DOMContentLoaded', function() {
    const cartButton = document.querySelector('.product-add-to-cart__button.add-to-cart');
    
    if (cartButton) {
        // Guardamos la posición original del botón para saber cuándo dejar de flotar
        const initialOffset = cartButton.offsetTop + cartButton.offsetHeight;

        window.addEventListener('scroll', function() {
            // Si el scroll pasa la posición original del botón
            if (window.scrollY > initialOffset) {
                if (!cartButton.classList.contains('is-floating-cart')) {
                    cartButton.classList.add('is-floating-cart');
                }
            } else {
                // Si vuelve a su posición original
                if (cartButton.classList.contains('is-floating-cart')) {
                    cartButton.classList.remove('is-floating-cart');
                }
            }
        });
    }
});

function gestionarVariantesPack() {
  const ids = window.variantMediaIds;
  if (!ids) return;

  const thumbnails = document.querySelectorAll('.thumbnail-gallery .thumbnail');
  
  // 1. Marcamos todas las que coincidan con IDs de variante
  thumbnails.forEach(img => {
    const currentId = img.getAttribute('data-media-id');
    if (ids.includes(currentId)) {
      img.classList.add('optModelos');
      img.classList.add('es-variacion');
    }
  });

  // 2. Quitamos la clase a la primera marcada (la del modelo)
  const primeraMarcada = document.querySelector('.thumbnail-gallery .thumbnail.es-variacion');
  if (primeraMarcada) {
    primeraMarcada.classList.remove('es-variacion');
  }
}

// Ejecución con reintentos para asegurar carga
window.addEventListener('load', gestionarVariantesPack);
setTimeout(gestionarVariantesPack, 1000);

function ponerEtiquetasPack() {
  // Limpiamos etiquetas viejas para que no se dupliquen
  document.querySelectorAll('.badge-pack-manual').forEach(b => b.remove());

  const marcadas = document.querySelectorAll('.thumbnail.es-variacion');
  
  marcadas.forEach(img => {
    const badge = document.createElement('span');
    badge.className = 'badge-pack-manual';
    badge.innerText = 'PACK';
    
    // Lo ponemos justo antes de la imagen
    img.parentNode.insertBefore(badge, img);
    
    // Lo posicionamos justo encima de la imagen actual
    badge.style.marginTop = (img.offsetTop + img.offsetHeight - 25) + "px";
    badge.style.marginLeft = (img.offsetLeft + (img.offsetWidth / 2) - 30) + "px";
  });
}

// Ejecutar después de tu JS que pone las clases
setTimeout(ponerEtiquetasPack, 1200);


function inyectarFotosEnOpciones() {
  const variants = window.productVariants;
  if (!variants) return;

  // 1. Buscamos todos los radio-options
  const radioOptions = document.querySelectorAll('.radio-option');

  radioOptions.forEach(option => {
    const input = option.querySelector('input.radio-input');
    const label = option.querySelector('label.radio-option__label');
    
    if (!input || !label) return;

    // 2. Buscamos la variante que coincida con el valor del input
    const valorInput = input.value;
    const varianteEncontrada = variants.find(v => v.title === valorInput || v.options.includes(valorInput));

    // 3. Si tiene imagen, la inyectamos
    if (varianteEncontrada && varianteEncontrada.featured_image) {
      // Verificamos si ya inyectamos la imagen para no duplicar
      if (label.querySelector('.img-variant-thumb')) return;

      const img = document.createElement('img');
      img.src = varianteEncontrada.featured_image.src;
      img.className = 'img-variant-thumb';
      
      // La insertamos al principio del label
      label.prepend(img);
    }
  });
}

// Ejecutar
window.addEventListener('load', inyectarFotosEnOpciones);
setTimeout(inyectarFotosEnOpciones, 1000);



// QUITAR CLP A PRECIOS
document.addEventListener("DOMContentLoaded", function() {
    const priceElements = document.querySelectorAll('.price-item--sale, .price-item--regular, .radio-option__price, .price__sale .price-item');

    priceElements.forEach(el => {
        // 1. Extraemos solo los números del texto (quita CLP, $, espacios, etc.)
        let rawNumber = el.innerText.replace(/\D/g, "");

        if (rawNumber) {
            // 2. Convertimos a formato de moneda chilena
            let formattedPrice = new Intl.NumberFormat('es-CL', {
                style: 'currency',
                currency: 'CLP',
                minimumFractionDigits: 0
            }).format(rawNumber);

            // 3. Reemplazamos el resultado (Intl ya pone el $ y los puntos)
            el.innerText = formattedPrice;
        }
    });
});

/* FICHA PROD. CHECKEAR SI HAY VIDEO */
// 1. Seleccionamos el contenedor padre específico por su ID
const parent = document.getElementById('shopify-section-template--16424526577726__custom_liquid_Jdp8E');

if (parent) {
    // 2. Buscamos si existe el wrapper del video dentro de este padre
    const videoExists = parent.querySelector('.video-section-wrapper');
    
    // 3. Verificamos si no existe o si existe pero está vacío
    if (!videoExists || videoExists.innerHTML.trim() === "") {
        parent.remove();
        console.log("Padre eliminado: no se encontró contenido de video.");
    }
}





//AGREGAR LABEL HOTSALE
/*
document.addEventListener("DOMContentLoaded", function() {
    // Buscamos los contenedores de productos. 
    // Ajusta '.card__inner' si tu tema usa otra clase (como '.product-card')
    const productCards = document.querySelectorAll('.card__inner, .product-card, .grid__item');

    productCards.forEach(card => {
        // Creamos el div con la clase solicitada
        const labelContainer = document.createElement('div');
        labelContainer.className = 'label_hotsale';
        
        // Estilo opcional para que el label flote sobre la imagen
        labelContainer.style.position = 'absolute';
        labelContainer.style.top = '16px';
        labelContainer.style.right = '16px';
        labelContainer.style.zIndex = '10';

        // Insertamos la imagen dentro del div
        labelContainer.innerHTML = `<img src="https://assets.hotsale.com.ar/assets/2026/imgs/icons/hotsale_date.svg" 
                                         style="display: inline-block; text-align: center; height: 70px; width: auto;" 
                                         alt="Hot Sale">`;
        
        // Aseguramos que la tarjeta sea el marco de referencia
        card.style.position = 'relative';
        
        // Insertamos el div al principio de la tarjeta de producto
        card.prepend(labelContainer);
    });
});
*/

// CONFIGURACIÓN
const COLECCION_BUSCADA = 'preventa';
const CLASE_PRODUCTO = '.product-card'; 
const SELECTOR_ENLACE = 'a[href*="/products/"]';

async function checkPreventaProducts() {
  const productCards = document.querySelectorAll(CLASE_PRODUCTO);

  productCards.forEach(async (card) => {
    const link = card.querySelector(SELECTOR_ENLACE);
    if (!link) return;

    // Obtener handle eliminando parámetros de búsqueda (?variant=...)
    const urlParts = link.getAttribute('href').split('/');
    const handleRaw = urlParts[urlParts.indexOf('products') + 1];
    const handle = handleRaw.split('?')[0];

    try {
      const isInCollection = await checkIfProductInCollection(handle, COLECCION_BUSCADA);

      if (isInCollection) {
        addPreventaBadge(card);
      }
    } catch (error) {
      console.error("Error al verificar producto:", handle, error);
    }
  });
}

async function checkIfProductInCollection(productHandle, collectionHandle) {
  try {
    const res = await fetch(`/collections/${collectionHandle}/products.json`);
    const data = await res.json();
    return data.products.some(p => p.handle === productHandle);
  } catch (e) {
    return false;
  }
}

// NUEVA FUNCIÓN CON ICONO DE MEDALLA Y ESTRUCTURA SOLICITADA
function addPreventaBadge(container) {
  if (container.querySelector('.gc-badge-top')) return; // Evitar duplicados

  const badgeHTML = `
    <div class="gc-badge-top" aria-label="Preventa">
      <svg class="gc-badge-star-medal" viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
        <path d="M12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28z"/>
      </svg>
      <span>PREVENTA 2</span>
    </div>
  `;

  // Asegurar que el contenedor permita posicionamiento absoluto
  container.style.setProperty('position', 'relative', 'important');
  
  // Insertar el HTML
  container.insertAdjacentHTML('beforeend', badgeHTML);
}

// Ejecutar al cargar la página
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', checkPreventaProducts);
} else {
  checkPreventaProducts();
}

// CONFIGURACIÓN MODO MUNDIAL
const COLECCION_BUSCADA2 = 'modo-mundial';
const CLASE_PRODUCTO2 = '.product-card'; 
const SELECTOR_ENLACE2 = 'a[href*="/products/"]';

async function checkPreventaProducts2() {
  const productCards = document.querySelectorAll(CLASE_PRODUCTO2);
  if (productCards.length === 0) return;

  // 1. Obtener todos los handles de la preventa en UNA SOLA petición
  const preventaHandles = await getCollectionProducts2(COLECCION_BUSCADA2);
  if (preventaHandles.size === 0) return;

  // 2. Iterar de forma eficiente
  productCards.forEach((card) => {
    const link = card.querySelector(SELECTOR_ENLACE2);
    if (!link) return;

    // Obtener handle eliminando parámetros de búsqueda (?variant=...)
    const urlParts = link.getAttribute('href').split('/');
    const handleRaw = urlParts[urlParts.indexOf('products') + 1];
    if (!handleRaw) return;
    const handle = handleRaw.split('?')[0];

    // 3. Búsqueda instantánea en el Set
    if (preventaHandles.has(handle)) {
      //addOfertaBadge(card);
    }
  });
}

// Devuelve un Set con los handles (máximo 250 productos)
async function getCollectionProducts2(collectionHandle) {
  try {
    // Agregamos ?limit=250 para evitar el límite por defecto de 30 productos de Shopify
    const res = await fetch(`/collections/${collectionHandle}/products.json?limit=250`);
    const data = await res.json();
    
    if (!data.products) return new Set();
    
    // Guardamos en un Set para que la búsqueda sea O(1)
    return new Set(data.products.map(p => p.handle));
  } catch (e) {
    console.error("Error al precargar la colección:", e);
    return new Set();
  }
}

function addOfertaBadge(container) {
  if (container.querySelector('.gc-badge-top')) return; 

  const badgeHTMLw = `
    <div class="gc-badge-top-oferta">
      <img src="https://cdn.shopify.com/s/files/1/0593/6198/4574/files/badge_modo_mundial.png?v=1781531286">
    </div>
  `;

  container.style.setProperty('position', 'relative', 'important');
  container.insertAdjacentHTML('beforeend', badgeHTMLw);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', checkPreventaProducts2);
} else {
  checkPreventaProducts2();
}


/* ---CALCULADORA NUEVA--- */


// ==========================================
// 1. BASE DE DATOS MAESTRA DE DISPOSITIVOS (Por Slugs)
// ==========================================
const DISPOSITIVOS_MASTER = {
    "ac": { nombre: "Aire Acondicionado", watts: 900, icono: "ac" },
    "ampolleta": { nombre: "Ampolleta", watts: 12, icono: "ampolleta" },
    "aspiradora": { nombre: "Aspiradora", watts: 700, icono: "aspiradora" },
    "bomba1hp": { nombre: "Bomba 1HP", watts: 746, icono: "bomba1hp" },
    "bomba2hp": { nombre: "Bomba 2HP", watts: 1500, icono: "bomba1hp" },
    "cafetera": { nombre: "Cafetera", watts: 600, icono: "cafetera" },
    "calefactor": { nombre: "Calefactor", watts: 1200, icono: "calefactor" },
    "camara": { nombre: "Cámara", watts: 8, icono: "camara" },
    "cocina": { nombre: "Encimera Cocina", watts: 1500, icono: "cocina" },
    "compresor": { nombre: "Compresor", watts: 800, icono: "compresor" },
    "consola": { nombre: "Consola Videojuegos", watts: 140, icono: "consola" },
    "cpap": { nombre: "Máquina CPAP", watts: 50, icono: "cpap" },
    "drone": { nombre: "Carga de Drone", watts: 60, icono: "drone" },
    "esmeril": { nombre: "Esmeril Angular", watts: 800, icono: "esmeril" },
    "gopro": { nombre: "Cámara GoPro", watts: 5, icono: "gopro" },
    "lampara": { nombre: "Lámpara de Mesa", watts: 25, icono: "lampara" },
    "lavadora": { nombre: "Lavadora", watts: 500, icono: "lavadora" },
    "licuadora": { nombre: "Licuadora", watts: 350, icono: "licuadora" },
    "linterna": { nombre: "Linterna Recargable", watts: 10, icono: "linterna" },
    "microondas": { nombre: "Microondas", watts: 1000, icono: "microondas" },
    "frigobar": { nombre: "Frigobar / Minibar", watts: 40, icono: "frigobar" },
    "notebook": { nombre: "Notebook", watts: 65, icono: "notebook" },
    "parlante": { nombre: "Parlante Bluetooth", watts: 30, icono: "parlante" },
    "plancha": { nombre: "Plancha de Ropa", watts: 1100, icono: "plancha" },
    "proyector": { nombre: "Proyector", watts: 120, icono: "proyector" },
    "refrigerador": { nombre: "Refrigerador", watts: 100, icono: "refrigerador" },
    "router": { nombre: "Router Wi-Fi", watts: 15, icono: "router" },
    "starlink": { nombre: "Antena Starlink", watts: 50, icono: "starlink" },
    "taladro": { nombre: "Taladro Eléctrico", watts: 550, icono: "taladro" }
};

// ==========================================
// 2. CONFIGURACIÓN DE PANELES SOLARES
// ==========================================
const ARREGLO_PANELES = [
    {
        id: "panel-0",
        nombre: "Sin Panel",
        bajada: "Uso solo con batería",
        watts: 0,
        imagenUrl: ""
    },
    {
        id: "panel-100",
        nombre: "Panel Compacto",
        bajada: "Plegable",
        watts: 100,
        imagenUrl: "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/panel_100.png?v=1780608296"
    },
    {
        id: "panel-200",
        nombre: "Panel Estándar",
        bajada: "Plegable",
        watts: 200,
        imagenUrl: "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/panel_100.png?v=1780608296"
    },
    {
        id: "panel-400",
        nombre: "Panel Pro",
        bajada: "Plegable",
        watts: 400,
        imagenUrl: "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/panel_100.png?v=1780608296"
    },
    {
        id: "panel-420",
        nombre: "Panel Pro",
        bajada: "Fijo",
        watts: 420,
        imagenUrl: "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/panel_fijo.png?v=1780608297"
    },
    {
        id: "panel-400",
        nombre: "Panel Pro",
        bajada: "Fijo",
        watts: 580,
        imagenUrl: "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/panel_fijo.png?v=1780608297"
    }
];

// ==========================================
// 3. ESTRUCTURA CRUDA DE MODELOS (Asociación por Slugs)
// ==========================================
const CONFIGURACION_ESTACIONES_CRUDAS = [
    {
        id: "nomad-mini-300",
        nameSelect: "Nomad Mini 300",
        lineaTexto1: "Nomad",
        lineaTexto2: "Mini",
        numeroModelo: "300",
        potenciaW: 300,
        capacidadWh: 288,
        maxSolarInputW: 120
    },
    {
        id: "hope-power-400",
        nameSelect: "Hope Power 400",
        lineaTexto1: "Hope",
        lineaTexto2: "Power",
        numeroModelo: "400",
        potenciaW: 400,
        capacidadWh: 1305,
        maxSolarInputW: 420
    },
    {
        id: "nomad-station-800",
        nameSelect: "Nomad Station 800",
        lineaTexto1: "Nomad",
        lineaTexto2: "Station",
        numeroModelo: "800",
        potenciaW: 800,
        capacidadWh: 512,
        maxSolarInputW: 200
    },
    {
        id: "adventure-energy-1200",
        nameSelect: "Adventure Energy 1200",
        lineaTexto1: "Adventure",
        lineaTexto2: "Energy",
        numeroModelo: "1200",
        potenciaW: 1200,
        capacidadWh: 960,
        maxSolarInputW: 500
    },
    {
        id: "explorer-solar-2000",
        nameSelect: "Explorer Solar 2000",
        lineaTexto1: "Explorer",
        lineaTexto2: "Solar",
        numeroModelo: "2000",
        potenciaW: 2000,
        capacidadWh: 1536,
        maxSolarInputW: 1200
    },
    {
        id: "explorer-solar-2000-b1",
        nameSelect: "Explorer Solar 2000 + 1 batería",
        lineaTexto1: "Explorer",
        lineaTexto2: "Solar",
        numeroModelo: "2000",
        potenciaW: 2000,
        capacidadWh: 3072,
        maxSolarInputW: 1200
    },
    {
        id: "explorer-solar-2000-b2",
        nameSelect: "Explorer Solar 2000 + 2 baterías",
        lineaTexto1: "Explorer",
        lineaTexto2: "Solar",
        numeroModelo: "2000",
        potenciaW: 2000,
        capacidadWh: 4608,
        maxSolarInputW: 1200
    },
    {
        id: "new-pathfinder-2800",
        nameSelect: "New Pathfinder 2800",
        lineaTexto1: "New",
        lineaTexto2: "Pathfinder",
        numeroModelo: "2800",
        potenciaW: 2800,
        capacidadWh: 2160,
        maxSolarInputW: 1200
    },
    {
        id: "freedom-solar-1200",
        nameSelect: "Freedom Solar 3600",
        lineaTexto1: "Freedom",
        lineaTexto2: "Solar",
        numeroModelo: "3600",
        potenciaW: 3600,
        capacidadWh: 3840,
        maxSolarInputW: 2000
    },
    {
        id: "freedom-solar-3600-b1",
        nameSelect: "Freedom 3600 + 1 batería",
        lineaTexto1: "Freedom",
        lineaTexto2: "Solar",
        numeroModelo: "3600",
        potenciaW: 3600,
        capacidadWh: 7680,
        maxSolarInputW: 2000
    },
    {
        id: "freedom-solar-3600-b2",
        nameSelect: "Freedom 3600 + 2 baterías",
        lineaTexto1: "Freedom",
        lineaTexto2: "Solar",
        numeroModelo: "3600",
        potenciaW: 3600,
        capacidadWh: 11520,
        maxSolarInputW: 2000
    },
    {
        id: "titan-power-7200",
        nameSelect: "Titan Power 7200",
        lineaTexto1: "Titan",
        lineaTexto2: "Power",
        numeroModelo: "7200",
        potenciaW: 7200,
        capacidadWh: 9792,
        maxSolarInputW: 3200
    }
];

// ==========================================
// 4. FILTRADO AUTOMÁTICO SEGÚN POTENCIA MÁXIMA DE LA ESTACIÓN
// ==========================================
function obtenerDispositivosAptosParaModelo(estacion) {
    const dispositivosFiltrados = [];
    
    // Recorremos la base maestra buscando qué dispositivos puede levantar esta estación
    for (const slug in DISPOSITIVOS_MASTER) {
        const infoMaster = DISPOSITIVOS_MASTER[slug];
        
        // REGLA AUTOMÁTICA: Si el consumo es menor o igual a la potencia de la estación, califica
        if (infoMaster.watts <= estacion.potenciaW) {
            dispositivosFiltrados.push({
                id: `${estacion.id}-${slug}`,
                nombre: infoMaster.nombre,
                watts: infoMaster.watts,
                icono: infoMaster.icono
            });
        }
    }
    
    // Opcional: Ordenar los dispositivos de menor a mayor consumo para que la grilla se vea ordenada
    return dispositivosFiltrados.sort((a, b) => a.watts - b.watts);
}

// Convertimos las estaciones crudas inyectándoles la función de filtrado automático
const ESTACIONES_MODELOS = CONFIGURACION_ESTACIONES_CRUDAS.map(estacion => {
    return {
        ...estacion,
        // La propiedad .dispositivos ahora se genera de forma dinámica en base al límite W
        get dispositivos() {
            return obtenerDispositivosAptosParaModelo(estacion);
        }
    };
});

// Variable global de estado que alimenta al renderizador
let modeloActivo = ESTACIONES_MODELOS[0];


// ==========================================
// 3. INICIALIZACIÓN Y CONFIGURACIÓN DE LA UI
// ==========================================
document.addEventListener("DOMContentLoaded", () => {
  // Verifica si el contenedor de la calculadora existe en el DOM
  const existeCalculadora = document.querySelector('.calculator-container') !== null;

  if (existeCalculadora) {
    poblarSelectorModelos();
    inicializarBateriaVisual();
    cargarPanelesSolares();
    actualizarEstacionYDispositivos();
    configurarEventosGlobales();
  }
});

function poblarSelectorModelos() {
    const select = document.getElementById('model-select');
    select.innerHTML = '';
    ESTACIONES_MODELOS.forEach((mod, index) => {
        const option = document.createElement('option');
        option.value = index;
        //option.textContent = `${mod.lineaTexto1} ${mod.lineaTexto2} ${mod.numeroModelo}`;
        option.textContent = `${mod.nameSelect}`;
        select.appendChild(option);
    });
}

function inicializarBateriaVisual() {
    // Inicializamos la principal
    const mainContainer = document.getElementById('battery-bar-container');
    if (mainContainer) construirBarrasEnContenedor(mainContainer);

    // Inicializamos la expansión izquierda
    const leftContainer = document.getElementById('battery-exp-left');
    if (leftContainer) construirBarrasEnContenedor(leftContainer);

    // Inicializamos la expansión derecha
    const rightContainer = document.getElementById('battery-exp-right');
    if (rightContainer) construirBarrasEnContenedor(rightContainer);
}

// Función auxiliar para no repetir código de renderizado de barras
function construirBarrasEnContenedor(container) {
    container.innerHTML = '';
    for (let i = 0; i < 10; i++) {
        const bar = document.createElement('div');
        bar.classList.add('battery-bar');
        container.appendChild(bar);
    }
}
// REEMPLAZO SEGURO PARA LA PARTE 3
function cargarPanelesSolares() {
    const container = document.getElementById('panels-container');
    container.innerHTML = '';

    ARREGLO_PANELES.forEach((panel, index) => {
        const isChecked = index === 0 ? "checked" : "";
        
        const label = document.createElement('div');
        label.classList.add('panel-option');
        
        // CORRECCIÓN: Solo agregar la clase si no está vacía
        if (index === 0) {
            label.classList.add('selected-panel');
        }
        
        label.setAttribute('data-watts', panel.watts);
        
        const imagenHTML = panel.watts === 0 
            ? `<div class="panel-image-placeholder empty-panel">0W</div>`
            : `<img src="${panel.imagenUrl}" alt="${panel.nombre}" class="panel-real-image" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';"><div class="panel-image-placeholder" style="display:none;">${panel.watts}W</div>`;

        const selectorHTML = panel.watts === 0
            ? ``
            : `<div class="panel-qty-controls">
                <button class="qty-btn minus-btn" type="button">−</button>
                <input type="number" class="panel-qty-input" value="0" min="1" readonly data-watts="${panel.watts}">
                <button class="qty-btn plus-btn" type="button">+</button>
               </div>`;

        label.innerHTML = `
            <input type="radio" name="solar-panel" value="${panel.watts}" ${isChecked}>
            ${imagenHTML}
            <div class="panel-info">
                <span class="panel-watts">${panel.watts === 0 ? panel.nombre : panel.watts + 'W'}</span>
                <span class="panel-desc">${panel.bajada}</span>
            </div>
            ${selectorHTML}
        `;

        label.addEventListener('click', (e) => {
            const radio = label.querySelector('input[type="radio"]');
            const qtyInput = label.querySelector('.panel-qty-input');
            
            if (label.classList.contains('disabled-panel') || e.target.classList.contains('qty-btn')) return;

            if (!radio.checked) {
                radio.checked = true;
                manejarCambioSeleccionPanel(label, qtyInput);
            }
        });

        if (panel.watts > 0) {
            const btnMinus = label.querySelector('.minus-btn');
            const btnPlus = label.querySelector('.plus-btn');
            const qtyInput = label.querySelector('.panel-qty-input');

            btnPlus.addEventListener('click', () => {
                let currentVal = parseInt(qtyInput.value);
                const maxPermitido = Math.floor(modeloActivo.maxSolarInputW / panel.watts);
                if (currentVal < maxPermitido) {
                    qtyInput.value = currentVal + 1;
                    calculateEverything();
                }
            });

            btnMinus.addEventListener('click', () => {
                let currentVal = parseInt(qtyInput.value);
                if (currentVal > 1) {
                    qtyInput.value = currentVal - 1;
                    calculateEverything();
                }
            });
        }
        container.appendChild(label);
    });
}


function manejarCambioSeleccionPanel(panelSeleccionado, inputSeleccionado) {
    document.querySelectorAll('.panel-option').forEach(opt => {
        opt.classList.remove('selected-panel');
        const input = opt.querySelector('.panel-qty-input');
        if (input) input.value = 0;
    });

    panelSeleccionado.classList.add('selected-panel');
    if (inputSeleccionado) inputSeleccionado.value = 1; 
    
    calculateEverything();
}

// ==========================================
// 6. VALIDACIONES Y NÚCLEO MATEMÁTICO EN TIEMPO REAL
// ==========================================
function validarRestriccionSolar() {
    let panelActivoSigueValido = true;

    document.querySelectorAll('.panel-option').forEach(label => {
        const panelWatts = parseInt(label.getAttribute('data-watts'));
        if (panelWatts === 0) return;

        const radio = label.querySelector('input[type="radio"]');
        const input = label.querySelector('.panel-qty-input');
        const maxPanelesPosibles = Math.floor(modeloActivo.maxSolarInputW / panelWatts);

        if (maxPanelesPosibles === 0) {
            label.classList.add('disabled-panel');
            radio.disabled = true;
            input.value = 0;
            label.classList.remove('selected-panel');
            if (radio.checked) {
                radio.checked = false;
                panelActivoSigueValido = false;
            }
        } else {
            label.classList.remove('disabled-panel');
            radio.disabled = false;
            
            if (radio.checked && parseInt(input.value) > maxPanelesPosibles) {
                input.value = maxPanelesPosibles;
            }
        }
    });

    if (!panelActivoSigueValido) {
        const divSinPanel = document.querySelector('.panel-option[data-watts="0"]');
        const radioSinPanel = divSinPanel.querySelector('input[type="radio"]');
        radioSinPanel.checked = true;
        divSinPanel.classList.add('selected-panel');
    }
}

function actualizarEstacionYDispositivos() {
    const logoContainer = document.getElementById('station-model-title');
    logoContainer.innerHTML = `
        <div class="logo-text-stack">
            <span class="logo-line-thin">${modeloActivo.lineaTexto1}</span>
            <span class="logo-line-bold">${modeloActivo.lineaTexto2}</span>
        </div>
        <div class="logo-number-giant">${modeloActivo.numeroModelo}</div>
    `;

    document.getElementById('station-specs-text').textContent = `${modeloActivo.potenciaW}W / ${modeloActivo.capacidadWh}Wh`;

    validarRestriccionSolar();

    // --- GESTIÓN VISUAL DE BATERÍAS DE EXPANSIÓN ---
    const bIzquierda = document.getElementById('battery-exp-left');
    const bDerecha = document.getElementById('battery-exp-right');

    if (modeloActivo.id === "freedom-solar-3600-b1" || modeloActivo.id === "explorer-solar-2000-b1") {
        if (bIzquierda) bIzquierda.style.setProperty('display', 'flex', 'important');
        if (bDerecha) bDerecha.style.display = 'none';
    } else if (modeloActivo.id === "freedom-solar-3600-b2" || modeloActivo.id === "explorer-solar-2000-b2") {
        if (bIzquierda) bIzquierda.style.setProperty('display', 'flex', 'important');
        if (bDerecha) bDerecha.style.setProperty('display', 'flex', 'important');
    } else {
        if (bIzquierda) bIzquierda.style.display = 'none';
        if (bDerecha) bDerecha.style.display = 'none';
    }
    // ------------------------------------------------

    const devicesContainer = document.getElementById('devices-container');
    devicesContainer.innerHTML = '';

    modeloActivo.dispositivos.forEach(disp => {
        const card = document.createElement('div');
        card.classList.add('device-card');
        
        card.innerHTML = `
            <input type="checkbox" value="${disp.watts}">
            <span class="device-icon"><img src="https://genectra.cl/cdn/shop/files/autonomia_${disp.icono}.svg?v=1778621432"></span>
            <span class="device-name">${disp.nombre}</span>
            <span class="device-watts">${disp.watts}W</span>
        `;

        card.addEventListener('click', (event) => {
            const checkbox = card.querySelector('input[type="checkbox"]');
            
            if (card.classList.contains('disabled-by-overload') && !checkbox.checked) {
                return; 
            }

            if (event.target !== checkbox) {
                checkbox.checked = !checkbox.checked;
            }
            card.classList.toggle('selected', checkbox.checked);
            calculateEverything();
        });

        devicesContainer.appendChild(card);
    });

    calculateEverything();
}


function calculateEverything() {
    let inputWatts = 0;
    
    const radioActivo = document.querySelector('input[name="solar-panel"]:checked');
    if (radioActivo) {
        const contenedorPadre = radioActivo.closest('.panel-option');
        const wattsUnitarios = parseInt(radioActivo.value);
        
        if (wattsUnitarios !== 0) {
            const inputCantidad = contenedorPadre.querySelector('.panel-qty-input');
            const cantidad = inputCantidad ? parseInt(inputCantidad.value) : 1;
            inputWatts = wattsUnitarios * cantidad;
        }
    }

    let outputWatts = 0;
    document.querySelectorAll('.devices-grid input[type="checkbox"]:checked').forEach(checkbox => {
        outputWatts += parseInt(checkbox.value);
    });

    const estaSobrecargado = outputWatts > modeloActivo.potenciaW;
    const bannerAlerta = document.getElementById('overload-alert');
    const displayOutput = document.getElementById('display-output');

    if (displayOutput) {
        if (estaSobrecargado) {
            displayOutput.classList.add('overloaded');
        } else {
            displayOutput.classList.remove('overloaded');
        }
    }

    if (bannerAlerta) {
        bannerAlerta.style.display = estaSobrecargado ? 'block' : 'none';
    }

    if (estaSobrecargado) {
        document.querySelectorAll('.device-card').forEach(card => {
            const checkbox = card.querySelector('input[type="checkbox"]');
            if (checkbox && !checkbox.checked) {
                card.classList.add('disabled-by-overload');
            }
        });
    } else {
        document.querySelectorAll('.device-card').forEach(card => {
            card.classList.remove('disabled-by-overload');
        });
    }

    const batteryPercentage = parseInt(document.getElementById('battery-slider').value);
    const currentWh = modeloActivo.capacidadWh * (batteryPercentage / 100);

    document.getElementById('display-input').innerText = String(inputWatts).padStart(3, '0') + 'W';
    if (displayOutput) displayOutput.innerText = String(outputWatts).padStart(3, '0') + 'W';
    document.getElementById('battery-text').innerText = batteryPercentage + '%';

    // --- AUTONIVELACIÓN DE TODAS LAS BATERÍAS VISIBLES ---
    const activeBarsCount = Math.ceil(batteryPercentage / 10);
    
    // Seleccionamos todas las barras de batería del DOM (de la principal y de las expansiones activas)
    const todosLosContenedores = document.querySelectorAll('.battery-container');
    todosLosContenedores.forEach(contenedor => {
        const bars = contenedor.querySelectorAll('.battery-bar');
        bars.forEach((bar, index) => {
            if (index < activeBarsCount) {
                bar.classList.add('active');
            } else {
                bar.classList.remove('active');
            }
        });
    });
    // -----------------------------------------------------

    const autonomyDisplay = document.getElementById('autonomy-display');
    const netWatts = inputWatts - outputWatts;

    if (estaSobrecargado) {
        const lossWatts = Math.abs(netWatts);
        const hoursRemaining = currentWh / lossWatts;
        autonomyDisplay.innerHTML = `<span style="color:#ef4444;">¡Exceso de carga! ${hoursRemaining.toFixed(1)} hrs descuidando el límite</span>`;
    } else if (outputWatts === 0 && inputWatts === 0) {
        autonomyDisplay.innerText = "Sistema en reposo";
    } else if (netWatts === 0) {
        autonomyDisplay.innerText = "Equilibrado (∞ hrs)";
    } else if (netWatts < 0) {
        const lossWatts = Math.abs(netWatts);
        const hoursRemaining = currentWh / lossWatts;
        autonomyDisplay.innerText = hoursRemaining.toFixed(1) + " hrs de autonomía restante";
    } else {
        if (batteryPercentage === 100) {
            autonomyDisplay.innerText = "Batería cargada al 100%";
        } else {
            const remainingWhToFull = modeloActivo.capacidadWh - currentWh;
            const hoursToFull = remainingWhToFull / netWatts;
            autonomyDisplay.innerText = hoursToFull.toFixed(1) + " hrs para carga completa";
        }
    }
}


function configurarEventosGlobales() {
    document.getElementById('battery-slider').addEventListener('input', calculateEverything);

    document.getElementById('model-select').addEventListener('change', (e) => {
        modeloActivo = ESTACIONES_MODELOS[e.target.value];
        actualizarEstacionYDispositivos();
    });
}



/* AJUSTES CARRITO PARA REGALO EXCLUSIVO */
(function() {
  // === CONFIGURACIÓN ===
  const ID_REGALO = 68022007562302; // ID de variante promocional
  const MONTO_LIMITE = 700000;       // Umbral de $700.000 pesos

  let operacionEnCurso = false;

  function procesarLogicaRegalo(cart) {
    if (operacionEnCurso) return;

    let subtotalSinRegalo = 0;
    let tieneRegalo = false;
    let regaloKey = null;

    // Calculamos el monto real aislando por completo el ítem de regalo
    cart.items.forEach(item => {
      if (item.variant_id === ID_REGALO) {
        tieneRegalo = true;
        regaloKey = item.key;
      } else {
        subtotalSinRegalo += item.final_line_price;
      }
    });

    const totalCalculado = subtotalSinRegalo / 100;

    // CASO 1: Supera los $700.000 y NO tiene el regalo en la cesta -> AGREGAR
    if (totalCalculado >= MONTO_LIMITE && !tieneRegalo) {
      operacionEnCurso = true;
      console.log(`%c[PROMO] Monto ($${totalCalculado.toLocaleString('es-CL')}) califica. Añadiendo regalo...`, "color: #27ae60; font-weight: bold;");
      
      ejecutarMutacionCarrito({
        updates: { [ID_REGALO]: 1 }
      });
    } 
    
    // CASO 2: Bajó del mínimo de compra y TIENE el regalo -> REMOVER
    else if (totalCalculado < MONTO_LIMITE && tieneRegalo) {
      operacionEnCurso = true;
      console.log(`%c[PROMO] Monto ($${totalCalculado.toLocaleString('es-CL')}) insuficiente. Removiendo regalo...`, "color: #c0392b; font-weight: bold;");

      ejecutarMutacionCarrito({
        updates: { [regaloKey]: 0 }
      });
    }
  }

  // Se encarga de enviar la actualización a Shopify y redibujar el tema Dawn por AJAX
  function ejecutarMutacionCarrito(datosModificacion) {
    const componenteCartDawn = document.querySelector('cart-items') || document.querySelector('cart-drawer');
    
    const seccionesDawn = componenteCartDawn && typeof componenteCartDawn.getSectionsToRender === 'function'
      ? componenteCartDawn.getSectionsToRender().map(section => section.id)
      : [];

    const datosFinales = {
      ...datosModificacion,
      sections: seccionesDawn,
      sections_url: window.location.pathname
    };

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(datosFinales)
    })
    .then(response => response.json())
    .then(estadoActualizado => {
      if (componenteCartDawn && seccionesDawn.length > 0 && estadoActualizado.sections) {
        componenteCartDawn.getSectionsToRender().forEach((section) => {
          const nodoDestino = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if (nodoDestino && estadoActualizado.sections[section.id]) {
            nodoDestino.innerHTML = componenteCartDawn.getSectionInnerHTML(estadoActualizado.sections[section.id], section.selector);
          }
        });
      } else {
        window.location.reload();
      }
    })
    .catch(err => console.error("Error al mutar el estado de la promoción:", err))
    .finally(() => {
      setTimeout(() => { operacionEnCurso = false; }, 300);
    });
  }

  // Interceptor a nivel de red para capturar solicitudes AJAX de mutación de stock hechas por Dawn
  const fetchOriginal = window.fetch;
  window.fetch = function(...args) {
    return fetchOriginal.apply(this, args).then(response => {
      const url = typeof args === 'string' ? args : (args && args.url) || '';
      
      if (/\/cart\/(change|update|add|clear)/.test(url) && response.ok && !operacionEnCurso) {
        response.clone().json().then(data => {
          if (!data.items) {
            fetchOriginal(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
              .then(r => r.json())
              .then(carritoCompleto => procesarLogicaRegalo(carritoCompleto));
          } else {
            procesarLogicaRegalo(data);
          }
        }).catch(()=>{});
      }
      return response;
    });
  };

  // === SOLUCIÓN VISUAL: Reemplaza los botones de cantidad por un texto estático "1" ===
  const estilosPromo = document.createElement('style');
  estilosPromo.innerHTML = `
    /* Oculta los elementos interactivos del control de cantidad sin romper la celda contenedora */
    .cart-item:has(a[href*="68022007562302"]) .quantity__button,
    .cart-item:has(a[href*="68022007562302"]) .quantity__input {
      display: none !important;
      visibility: hidden !important;
    }

    /* Mantiene el contenedor del tamaño correcto e inyecta un texto estático con el número "1" */
    .cart-item:has(a[href*="68022007562302"]) .quantity.js-quantity {
      border: none !important;
      background: transparent !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      min-height: 40px;
    }
    
    .cart-item:has(a[href*="68022007562302"]) .quantity.js-quantity::after {
      content: "1" !important;
      font-size: 16px;
      font-weight: bold;
      color: currentColor;
    }

    /* Oculta los botones de eliminar (Móvil y Escritorio) en la fila del regalo */
    .cart-item:has(a[href*="68022007562302"]) .js-cart-item-remove,
    .cart-item:has(a[href*="68022007562302"]) [id^="Remove-"],
    .cart-item:has(a[href*="68022007562302"]) .cart-item__cta {
      display: none !important;
      visibility: hidden !important;
    }
  `;
  document.head.appendChild(estilosPromo);

  // Evaluación inicial pasiva al renderizarse el DOM por primera vez en el navegador
  document.addEventListener('DOMContentLoaded', () => {
    fetchOriginal(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(carritoInicial => procesarLogicaRegalo(carritoInicial))
      .catch(()=>{});
  });
})();



